<template>
  <ckeditor id="editor"
            :editor="editor"
            :config="config"
            v-model="data"
            @input="handle_input"
            />
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';

export default {
  name: 'DocEditor',
  props: ['placeholder', 'value'],
  components: {
    ckeditor: CKEditor.component,
  },
  data: function () {
    return {
      data: this.value,
      config: {
        placeholder: this.placeholder,
        toolbar: [ 'heading', 'bold', 'italic', 'blockquote', '|', 'undo', 'redo',
          '|', 'numberedlist', 'bulletedlist',
          'inserttable', 'tablecolumn', 'tablerow'],
      },
      editor: BalloonEditor,
    };
  },
  computed: {
  },
  methods: {
    handle_input() {
      this.$emit('input', this.data);
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

